import { Component } from '@theme/component';
import { fetchConfig } from '@theme/utilities';

const COOKIE_NAME = 'wholesale_mode';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

function readCookie() {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return match ? match[1] === 'true' : false;
}

function writeCookie(enabled) {
  document.cookie = `${COOKIE_NAME}=${enabled}; path=/; max-age=${enabled ? COOKIE_MAX_AGE_SECONDS : 0}`;
}

export function isWholesaleMode() {
  return document.documentElement.dataset.wholesaleMode === 'true';
}

/**
 * Persists the mode as a cart attribute (source of truth for server-side rendering
 * and for any app/checkout logic that wants to read it) and reloads so every price,
 * quantity minimum, and banner on the page re-renders from that server state.
 */
async function setWholesaleMode(enabled) {
  writeCookie(enabled);
  await fetch(
    Theme.routes.cart_update_url,
    fetchConfig('json', { body: JSON.stringify({ attributes: { wholesale_mode: enabled ? 'true' : '' } }) })
  );
  window.location.reload();
}

// The inline head script already set data-wholesale-mode from the cookie for instant,
// flash-free paint. If that disagrees with the server-rendered cart attribute (e.g. the
// cart expired and dropped its attributes), re-arm the cart attribute in the background
// so it doesn't silently fall out of sync with what the shopper's cookie says.
// ponytail: doesn't retry on fetch failure — acceptable, next page load retries anyway.
if (readCookie() && !isWholesaleMode()) {
  document.documentElement.setAttribute('data-wholesale-mode', 'true');
  fetch(Theme.routes.cart_update_url, fetchConfig('json', { body: JSON.stringify({ attributes: { wholesale_mode: 'true' } }) }));
}

class WholesaleToggleComponent extends Component {
  toggle() {
    setWholesaleMode(!isWholesaleMode());
  }
}

class WholesaleBannerComponent extends Component {
  dismiss() {
    sessionStorage.setItem('wholesale_banner_dismissed', 'true');
    document.documentElement.setAttribute('data-wholesale-banner-dismissed', 'true');
  }
}

if (!customElements.get('wholesale-toggle-component')) {
  customElements.define('wholesale-toggle-component', WholesaleToggleComponent);
}
if (!customElements.get('wholesale-banner-component')) {
  customElements.define('wholesale-banner-component', WholesaleBannerComponent);
}